// extracted by mini-css-extract-plugin
export default {"root":"Loader__root--2OdV0","title":"Loader__title--3o4l-","quota":"Loader__quota--qWjjv","button":"Loader__button--2HLlH"};